import type { Country } from '@kitopi-com/customer-auth';
import {
  ACCESS_TIME_IN_MINUTES,
  API_URL,
  FIREBASE_COUNTRIES_PATH,
  FIREBASE_DATABASE_URL,
} from 'utils/constants';
import { parseFirebaseCountries } from 'utils/parseFirebaseCountries';
import { post } from './request';

interface LoginGuestParams {
  macAddress: string;
  apMacAddress?: string;
  siteName?: string;
  ssid?: string;
}

interface LoginGuestResponse {
  isSuccess: boolean;
  statusCode?: number;
  message?: string;
}

interface CheckIsGuestSignedInResponse {
  isAuthorized: boolean;
  statusCode?: number;
}

export const loginGuest = async ({
  macAddress,
  apMacAddress,
  ssid,
  siteName,
}: LoginGuestParams): Promise<LoginGuestResponse> => {
  try {
    const response = await post<LoginGuestResponse>(`${API_URL}login`, {
      macAddress,
      apMacAddress,
      accessTimeInMinutes: ACCESS_TIME_IN_MINUTES,
      ssid,
      siteName,
    });
    return response;
  } catch (error) {
    throw new Error(`Login guest error:  ${error}`);
  }
};

export const checkIsGuestSignedIn = async ({ macAddress, siteName, ssid }: LoginGuestParams) => {
  try {
    const res = await post<CheckIsGuestSignedInResponse>(`${API_URL}check-is-guest-signed-in`, {
      macAddress,
      siteName,
      ssid,
    });
    return !!res?.isAuthorized;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

interface Site {
  anonymous_id: string;
  name: string;
  external_id: string;
  _id: string;
  desc: string;
  role: string;
  device_count: number;
}

export const fetchCountriesFromFirebase = async (): Promise<Country[]> => {
  if (!FIREBASE_DATABASE_URL) {
    throw new Error('FIREBASE_DATABASE_URL is not configured');
  }

  const url = `${FIREBASE_DATABASE_URL}/${FIREBASE_COUNTRIES_PATH}.json`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Firebase HTTP error: ${response.status}`);
  }

  const data = (await response.json()) as unknown;

  return parseFirebaseCountries(data) as Country[];
};

export const getSites = async () => {
  try {
    const res = await post<Site[]>(`${API_URL}sites`);
    return res;
  } catch (error) {
    throw new Error(`Get sites error:  ${error}`);
  }
};
